export default __webpack_public_path__ + "static/media/envelope.d301acbd.svg";